import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const links = [
  { to: "/paper", label: "Paper" },
  { to: "/modules", label: "Modules" },
  { to: "/method", label: "Method" },
  { to: "/pricing", label: "Fees" },
  { to: "/dealers", label: "Dealers" },
  { to: "/about", label: "About" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="no-print sticky top-0 z-40 bg-paper border-b border-rule" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="t-head text-2xl tracking-[0.08em] text-carbon" data-testid="wordmark-link">LONGHAND</Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) => `t-label transition-colors ${isActive ? "text-carbon underline underline-offset-4" : "text-olive hover:text-carbon"}`}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/audit" className="btn btn-stamp" data-testid="header-audit-btn">Take the Audit</Link>
        </nav>
        <button className="md:hidden t-label text-carbon" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? "Close" : "Menu"}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-rule bg-paper px-5 py-5 flex flex-col gap-4 settle" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="t-label text-carbon" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>{l.label}</NavLink>
          ))}
          <Link to="/audit" onClick={() => setOpen(false)} className="btn btn-stamp self-start" data-testid="mobile-audit-btn">Take the Audit</Link>
        </div>
      )}
    </header>
  );
};
